import { MenuState, Store } from 'store/types';
import { NavGroupType } from '../../../../../menu-items/types';
import { Box, Typography } from '@mui/material';
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import config from '../../../../../config';

import { useSelector } from 'react-redux';

function loadMenuItems(
    extensions: MenuState['extensions'],
): Array<NavGroupType> {
    const items: Array<NavGroupType> = [];

    for (const item of config.acceptableMenuExtensions) {
        const menuItems = item.items;
        let lastIndex = 0;

        for (const endpoint of extensions.endpoints || []) {
            if (
                typeof menuItems.disabled !== 'undefined' &&
                menuItems.disabled[endpoint]
            ) {
                const sortIndex =
                    menuItems.disabled[endpoint]?.index ?? lastIndex + 1;

                menuItems.children[sortIndex] = menuItems.disabled[endpoint];
                lastIndex++;
            }
        }

        if (
            Object.keys(menuItems.children).length > 0 &&
            extensions.enabled?.includes(item.name)
        ) {
            items.push(menuItems);
        }
    }

    return items;
}

const Navigation = () => {
    const { extensions } = useSelector<Store, MenuState>(state => state.menu);

    const items: Array<NavGroupType> = [
        menuItem.dashboard,
        ...loadMenuItems(extensions),
    ];

    const navGroups = items.map(item => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography
                        key={item.id}
                        variant="h6"
                        color="error"
                        align="center">
                        Fix - Navigation Group
                    </Typography>
                );
        }
    });

    return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
